import './SuccessPage.css';
import React, { JSX, useEffect } from 'react';
import { Routes } from '../../../app/Routes';
import { CheckMark } from '../../../assets/svg/CheckMark';
import { Button } from '../../../components/Button/Button';
import { localized } from '../../../config/localization';
import { Link, useNavigate } from 'react-router';
import { clearSkipSubmitCheck } from '../Checkout';

export function SuccessPage(): JSX.Element {
  const navigate = useNavigate();

  useEffect(() => {
    clearSkipSubmitCheck();
  }, []);

  return (
    <div className="success-page">
      <CheckMark fill="currentColor" />
      <div>{localized.THANK_YOU}</div>
      <div>
        {localized.ORDER_PLACED1}
        <div>
          {localized.ORDER_PLACED2} <Link to={Routes.CUSTOMER_ORDERS}>{localized.RECENT_ORDERS} </Link>
          {localized.ORDER_PLACED3}
          <div>{localized.ORDER_PLACED4}</div>
        </div>
      </div>
      <Button
        onClick={() => {
          navigate(Routes.CHECKOUT_UPLOAD, {
            replace: true,
          });
        }}
        secondary
        dataCy="button-success-page-new-order"
      >
        {localized.CREATE_NEW_ORDER}
      </Button>
    </div>
  );
}
